import { ControllerPaletteColor } from './__palette-color';

export enum ControllerFormControlColor {
  HelperTextDefaultFg = ControllerPaletteColor.Gray400,
  HelperTextDisabledFg = ControllerPaletteColor.Gray400,
  HelperTextErrorFg = ControllerPaletteColor.Red500,
  HelperTextFocusFg = ControllerPaletteColor.Gray400,
  HelperTextRequiredFg = ControllerPaletteColor.Gray400,

  LabelAsteriskFg = ControllerPaletteColor.Red500,
  LabelDefaultFg = ControllerPaletteColor.Gray400,
  LabelDisabledFg = ControllerPaletteColor.Gray400,
  LabelErrorFg = ControllerPaletteColor.Red500,
  LabelFocusFg = ControllerPaletteColor.Ngb400,

  TopRightAdornmentDefaultFg = ControllerPaletteColor.Ngb500,
  TopRightAdornmentDisabledFg = ControllerPaletteColor.Gray400,
}
